import * as React from 'react'
import classnames from 'classnames'
import { Props, buttonConfiguration, State } from './types'
// @ts-ignore
import ICON_CARET from '../../assets/caret.svg'
// @ts-ignore
import ICON_CLOSE from '../../assets/close-icon.svg'
import './styles.scss'

/**
 * @description
 * @author Jonathan IBOR
 * @export
 * @class ButtonMultipleChoices
 * @extends {React.Component<Props, State>}
 */
export class ButtonMultipleChoices extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      reset: props.reset || false,
    }

    this.colorButton = this.colorButton.bind(this)
    this.onHandleResetElements = this.onHandleResetElements.bind(this)
  }

  componentDidUpdate(nextProps: Props) {
    if (this.props.reset !== nextProps.reset) {
      this.setState({ reset: this.props.reset as any })
    }
  }

  colorButton(): string {
    const { color } = this.props

    const colorButton = buttonConfiguration.find(item => item === color)

    if (colorButton) {
      return `buttonMultipleChoices__${colorButton}`
    }

    return ''
  }

  onHandleResetElements(e: any) {
    e.stopPropagation()
    if (this.props.resetElements) {
      this.props.resetElements(!this.state.reset)
    }

    this.setState({ reset: true })
  }

  render() {
    const {
      label,
      onHandlePrimaryButton,
      onHandleSecondaryButton,
      children,
      isSelected,
      isFocus,
      icon: Icon,
      headerButton,
      disabled,
    } = this.props

    return (
      <button
        className={classnames(this.colorButton(), 'buttonMultipleChoices', disabled ? 'disabled' : '', isSelected && 'buttonMultipleChoices__selected', headerButton && 'buttonMultipleChoices__headerBtn', isFocus && 'buttonMultipleChoices__focus')}
        onClick={(e) => onHandlePrimaryButton(e)}
      >
        <div className="buttonMultipleChoices__wrapper">
          <span className="buttonMultipleChoices__label">
            {label}
          </span>
          { (!Icon && !this.state.reset) && (
            <div
              className="buttonMultipleChoices__close"
              onClick={(e) => this.onHandleResetElements(e)}
            >
              <ICON_CLOSE />
            </div>
          )}
          { !Icon && this.state.reset && (
            <div
              className="buttonMultipleChoices__caret"
              onClick={(e) => onHandleSecondaryButton(e)}
            >
              <ICON_CARET />
            </div>
          )}
          {
            Icon && (
              <div
                className="buttonMultipleChoices__caret"
                onClick={(e) => onHandleSecondaryButton(e)}
              >
                { Icon }
              </div>
            )
          }
        </div>
        { children }
      </button>
    )
  }
}
